import { useEffect } from 'react';
import { analyticsConfig } from '../../config/analytics';

const appendScriptBeforeFirstScript = (script) => {
  const firstScript = document.getElementsByTagName('script')[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
};

const Analytics = () => {
  useEffect(() => {
    // 1. Injetar Microsoft Clarity
    if (analyticsConfig.clarityId && analyticsConfig.clarityId !== 'SUA_CHAVE_AQUI') {
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        appendScriptBeforeFirstScript(t);
      })(window, document, "clarity", "script", analyticsConfig.clarityId);
    }

    // 2. Injetar Google Analytics (GA4)
    if (analyticsConfig.gaId && analyticsConfig.gaId !== 'SEU_ID_GA4') {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsConfig.gaId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', analyticsConfig.gaId);
    }

    // 3. Injetar Meta Pixel
    if (analyticsConfig.pixelId && analyticsConfig.pixelId !== 'SEU_PIXEL_ID') {
      (function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      appendScriptBeforeFirstScript(t)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js'));
      window.fbq('init', analyticsConfig.pixelId);
      window.fbq('track', 'PageView');

      // Adicionar NoScript para Meta Pixel
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${analyticsConfig.pixelId}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }

    // 4. Injetar Mixpanel
    if (analyticsConfig.mixpanelToken && analyticsConfig.mixpanelToken !== 'SEU_TOKEN_MIXPANEL') {
      /* eslint-disable */
      (function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split(".");2==b.length&&(a=a[b[0]],d=b[1]);a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)))}}var a=b;"undefined"!==typeof c?a=b[c]=[]:c="mixpanel";a.people=a.people||[];a.toString=function(a){var d="mixpanel";"mixpanel"!==c&&(d+="."+c);a||(d+=" (stub)");return d};a.people.toString=function(){return a.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
      for(h=0;h<i.length;h++)g(a,i[h]);var j="key";"undefined"!==typeof c&&(j="token");a[j]=e;b._i.push([e,f,c])};b.__SV=1.2;e=f.createElement("script");e.type="text/javascript";e.async=!0;e.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===f.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";appendScriptBeforeFirstScript(e)}})(window,window.mixpanel||[]);
      /* eslint-enable */

      window.mixpanel.init(analyticsConfig.mixpanelToken, { track_pageview: true });
    }
  }, []);

  return null; // Este componente não renderiza nada visualmente
};

export default Analytics;
